<template>
  <section class="admin-page">

    <!-- Header -->
    <header class="admin-header">
      <h1>Admin Profile</h1>
      <p>Your identity and access context for platform governance.</p>
    </header>

    <!-- Profile Summary -->
    <section class="summary-grid">

      <div class="card">
        <p class="label">Name</p>
        <h3>{{ profile.name }}</h3>
      </div>

      <div class="card">
        <p class="label">Email</p>
        <h3>{{ profile.email }}</h3>
      </div>

      <div class="card">
        <p class="label">Role</p>
        <span class="role-pill">{{ profile.role }}</span>
      </div>

      <div class="card">
        <p class="label">Status</p>
        <span class="status-pill active">Active</span>
      </div>

    </section>

    <!-- Details -->
    <section class="details-layout">

      <!-- Identity -->
      <div class="card">
        <h3>Identity</h3>

        <div class="info-row">
          <span>Email Verified</span>
          <span class="status-pill ok">Yes</span>
        </div>

        <div class="info-row">
          <span>Two-Factor Auth</span>
          <span class="status-pill ok">Enabled</span>
        </div>

        <div class="info-row">
          <span>Created On</span>
          <strong>{{ profile.created }}</strong>
        </div>

        <div class="info-row">
          <span>Last Login</span>
          <strong>{{ profile.lastLogin }}</strong>
        </div>
      </div>

      <!-- Permissions -->
      <div class="card">
        <h3>Permissions</h3>

        <ul class="perm-list">
          <li v-for="p in profile.permissions" :key="p">
            {{ p }}
          </li>
        </ul>
      </div>

    </section>

    <!-- Sessions -->
    <section class="card">
      <h3>Active Sessions</h3>

      <table class="session-table">
        <thead>
          <tr>
            <th>Device</th>
            <th>IP</th>
            <th>Location</th>
            <th>Last Activity</th>
            <th></th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="s in sessions" :key="s.id">
            <td>{{ s.device }}</td>
            <td class="mono">{{ s.ip }}</td>
            <td>{{ s.location }}</td>
            <td>{{ s.last }}</td>
            <td>
              <button class="danger-btn" @click="revoke(s)">
                Revoke
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </section>

  </section>
</template>

<script>
export default {
  name: "AdminProfile",

  data() {
    return {
      profile: {
        name: "Super Admin",
        email: "admin@vault.io",
        role: "Super Admin",
        created: "2023-08-12",
        lastLogin: "Today, 09:22",
        permissions: [
          "Creator Approval",
          "Broadcast Oversight",
          "System Configuration",
          "Security Management",
          "Audit Log Access"
        ]
      },

      sessions: [
        {
          id: 1,
          device: "Chrome / macOS",
          ip: "103.21.44.18",
          location: "Bangalore, IN",
          last: "2 minutes ago"
        },
        {
          id: 2,
          device: "Edge / Windows",
          ip: "49.36.22.91",
          location: "Delhi, IN",
          last: "Yesterday"
        }
      ]
    };
  },

  methods: {
    revoke(session) {
      this.sessions = this.sessions.filter(s => s.id !== session.id);
      alert("Session revoked");
    }
  }
};
</script>

<style scoped>
.admin-page {
  max-width: 1440px;
  margin: auto;
  padding: 48px;
}

.admin-header h1 {
  font-size: 36px;
  font-weight: 800;
}

.admin-header p {
  color: #64748b;
  margin-top: 6px;
}

/* Summary */
.summary-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  margin: 40px 0;
}

.card {
  background: white;
  border-radius: 20px;
  padding: 24px;
  border: 1px solid #e5e7eb;
}

.label {
  font-size: 11px;
  text-transform: uppercase;
  color: #94a3b8;
  font-weight: 700;
}

/* Details */
.details-layout {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  margin-bottom: 40px;
}

.info-row {
  display: flex;
  justify-content: space-between;
  padding: 12px 0;
  border-bottom: 1px solid #f1f5f9;
}

/* Permissions */
.perm-list {
  margin-top: 12px;
  padding-left: 18px;
}

.perm-list li {
  font-size: 14px;
  margin-bottom: 6px;
}

/* Sessions */
.session-table {
  width: 100%;
  border-collapse: collapse;
}

.session-table th,
.session-table td {
  padding: 14px;
  text-align: left;
  border-bottom: 1px solid #f1f5f9;
  font-size: 14px;
}

.mono {
  font-family: monospace;
}

/* Pills */
.role-pill {
  font-size: 11px;
  padding: 4px 10px;
  border-radius: 999px;
  background: #f1f5f9;
  font-weight: 800;
}

.status-pill {
  font-size: 11px;
  padding: 4px 10px;
  border-radius: 999px;
  font-weight: 800;
}

.status-pill.ok,
.status-pill.active {
  background: #ecfdf5;
  color: #047857;
}

/* Buttons */
.danger-btn {
  background: #991b1b;
  color: white;
  padding: 6px 12px;
  border-radius: 10px;
  font-weight: 700;
}

/* Mobile */
@media (max-width: 900px) {
  .summary-grid,
  .details-layout {
    grid-template-columns: 1fr;
  }

  .admin-page {
    padding: 24px;
  }
}
/* ===============================
   ADMIN PROFILE – MOBILE PATCH
   =============================== */
@media (max-width: 640px) {

  /* Page padding */
  .admin-page {
    padding: 20px 16px 72px;
  }

  /* Header */
  .admin-header h1 {
    font-size: 26px;
    line-height: 1.2;
  }

  .admin-header p {
    font-size: 14px;
  }

  /* Summary cards */
  .summary-grid {
    gap: 12px;
    margin: 24px 0;
  }

  .summary-grid .card {
    padding: 16px;
    border-radius: 16px;
  }

  /* Details cards */
  .details-layout {
    gap: 16px;
    margin-bottom: 24px;
  }

  .card h3 {
    font-size: 18px;
    margin-bottom: 14px;
  }

  /* Info rows → vertical */
  .info-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
    padding: 10px 0;
  }

  .info-row strong {
    font-size: 14px;
  }

  /* Permissions */
  .perm-list {
    padding-left: 16px;
  }

  .perm-list li {
    font-size: 13px;
  }

  /* Sessions table → stacked cards */
  .session-table thead {
    display: none;
  }

  .session-table,
  .session-table tbody,
  .session-table tr,
  .session-table td {
    display: block;
    width: 100%;
  }

  .session-table tr {
    padding: 14px 0;
    border-bottom: 1px solid #f1f5f9;
  }

  .session-table td {
    padding: 6px 0;
    border: none;
    font-size: 14px;
    word-break: break-word;
  }

  .mono {
    font-size: 12px;
  }

  /* Revoke button */
  .danger-btn {
    width: 100%;
    padding: 10px 14px;
    margin-top: 6px;
    border-radius: 12px;
  }
}

</style>
